import { render, staticRenderFns } from "./HeaderItem.vue?vue&type=template&id=7d56549e&scoped=true&"
import script from "./HeaderItem.vue?vue&type=script&lang=ts&"
export * from "./HeaderItem.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderItem.vue?vue&type=style&index=0&id=7d56549e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d56549e",
  null
  
)

export default component.exports